












import Vue from "vue";
import DocumentToolbarAction from "@/components/modules/document/toolbar/DocumentToolbarAction.vue";
export default Vue.extend({
    name: "ShowChangesComparedToPreviousVersion",
    components: { DocumentToolbarAction },
    props: {
        enable: Boolean
    },
    methods: {
        setShowChangesComparedToPrevious(): void {
            this.$emit("show-changes-compared-to-previous");
        }
    }
});
